// extracted by mini-css-extract-plugin
module.exports = {"magicSymbol":"textWithMagicSymbol_magicSymbol__OUnHa","imageContainer":"textWithMagicSymbol_imageContainer__rfmV5"};